module.exports = __webpack_public_path__ + "media/images/checkout/challenger/email_saved-6665b4c262a0d7d0f81c9df3ceae31ad.svg";